export const messages = {
  en: {
    layout: {
      switchLanguage: 'Switch Language',
      chinese: 'Chinese',
      english: 'English',
      home: 'Home',
      businessManagement: 'Business Management',
      propertyManagement: 'Property',
      userManagement: 'User',
      OAManagement: 'OA',
      parkingManagement: 'Parking',
      monitoringManagement: 'Monitoring',
      settingManagement: 'Settings',
      logout: 'Logout',
      machineManagement: 'Machine Management',
      tenantManagement: 'Tenant Management',
      systemManagement: 'System Management',
      menuGroup: 'Menu Group',
      machine: 'Machine',
      tenant: 'Tenant',
      project: 'Project',
      machineList: 'Machine List',
      machineAdd: 'Add Machine',
      machineEdit: 'Edit Machine',
      machineCode: 'Machine Code',
      machineName: 'Machine Name',
      machineIp: 'Machine IP',
      machineMac: 'Machine MAC',
      machineType: 'Machine Type',
      implBean: 'Manufacturer',
      heartbeatTime: 'Heartbeat Time',
      status: 'Status',
      inUse: 'In Use',
      invalid: 'Invalid',
      remark: 'Remark',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
      required: 'This field is required',
      addSuccess: 'Add success',
      editSuccess: 'Edit success',
      deleteSuccess: 'Delete success',
      deleteConfirm: 'Are you sure to delete this item?',
      tip: 'Tip',
      fetchError: 'Failed to fetch data',
      deleteError: 'Failed to delete',
      submitError: 'Failed to submit',
      moreCommunity:'More Community',
      closeAllTabs: 'Close All'
    }
  },
  zh: {
    layout: {
      switchLanguage: '切换语言',
      chinese: '中文',
      english: '英文',
      home: '首页',
      businessManagement: '业务管理',
      propertyManagement: '物业管理',
      userManagement: '用户管理',
      OAManagement: 'OA管理',
      parkingManagement: '停车管理',
      monitoringManagement: '监控管理',
      settingManagement: '设置',
      logout: '退出',
      machineManagement: '设备管理',
      tenantManagement: '租户管理',
      systemManagement: '系统管理',
      machine: '设备',
      tenant: '租户',
      project: '项目',
      menuGroup: '菜单组',
      machineList: '设备列表',
      machineAdd: '添加设备',
      machineEdit: '编辑设备',
      machineCode: '设备编码',
      machineName: '设备名称',
      machineIp: '设备IP',
      machineMac: '设备MAC',
      machineType: '设备类型',
      implBean: '门禁厂家',
      heartbeatTime: '心跳时间',
      status: '状态',
      inUse: '在用',
      invalid: '失效',
      remark: '备注',
      operation: '操作',
      edit: '编辑',
      delete: '删除',
      cancel: '取消',
      confirm: '确定',
      required: '此字段为必填项',
      addSuccess: '添加成功',
      editSuccess: '编辑成功',
      deleteSuccess: '删除成功',
      deleteConfirm: '确定要删除此项吗？',
      tip: '提示',
      fetchError: '获取数据失败',
      deleteError: '删除失败',
      submitError: '提交失败',
      moreCommunity:'更多园区',
      closeAllTabs: '关闭所有'
    }
  },
  'zh-TW': {
    layout: {
      switchLanguage: '切換語言',
      chinese: '中文',
      english: '英文',
      home: '首頁',
      businessManagement: '業務管理',
      propertyManagement: '物業管理',
      userManagement: '用戶管理',
      OAManagement: 'OA管理',
      parkingManagement: '停車管理',
      monitoringManagement: '監控管理',
      settingManagement: '設置',
      logout: '退出',
      machineManagement: '設備管理',
      tenantManagement: '租戶管理',
      systemManagement: '系統管理',
      machine: '設備',
      tenant: '租戶',
      project: '項目',
      menuGroup: '菜單組',
      machineList: '設備列表',
      machineAdd: '添加設備',
      machineEdit: '編輯設備',
      machineCode: '設備編碼',
      machineName: '設備名稱',
      machineIp: '設備IP',
      machineMac: '設備MAC',
      machineType: '設備類型',
      implBean: '門禁廠家',
      heartbeatTime: '心跳時間',
      status: '狀態',
      inUse: '在用',
      invalid: '失效',
      remark: '備註',
      operation: '操作',
      edit: '編輯',
      delete: '刪除',
      cancel: '取消',
      confirm: '確定',
      required: '此字段為必填項',
      addSuccess: '添加成功',
      editSuccess: '編輯成功',
      deleteSuccess: '刪除成功',
      deleteConfirm: '確定要刪除此項嗎？',
      tip: '提示',
      fetchError: '獲取數據失敗',
      deleteError: '刪除失敗',
      submitError: '提交失敗',
      moreCommunity:'更多小區',
      closeAllTabs: '關閉所有'
    }
  }
} 